export default {
  home: {
    language: '语言',
    theme: '主题',
    dark: '暗黑',
    light: '明亮'
  },
  dashboard: {
    to: '至'
  },
  mediahub: {
    subscription: '订阅管理',
    yearly: '年卡',
    demand: '当前服务',
    subscribeDemand: '订阅当前服务',
    managed: '附加服务',
    subscribeManaged: '订阅附加服务',
    reselect: '更改套餐',
    deactivate: '取消连续订阅',
    subscriptionTip: '为什么取消连续订阅？',
    saveMoney: '省钱',
    feature: '没有想要的功能',
    other: '其它',
    liveTip: '温馨提示：取消订阅后无法推流',
    plan: '选择套餐',
    monthly: '月卡',
    payperuse: '按次付费',
    inputPeview: '输入预览',
    month: '/月',
    year: '/年',
    perInput: '每可推流的源',
    output: '推流',
    perOuput: '每推流',
    format: '编解码格式',
    bitrateTip1: '每比特率达10Mbps的编解码配置文件',
    bitrateTip2: '每比特率达30Mbps的编解码配置文件',
    choosePlan: '配置此套餐',
    back: '返回',
    remainTip: '你的账户余额将自动叠加到新的订阅',
    inputStream: '输入流',
    outputStream: '输出流',
    lowBitrate: '低视频比特率编解码',
    highBitrate: '高视频比特率编解码',
    buy: '订阅',
    cloudSubscription: '当前服务订阅',
    core: 'CPU核数',
    node: '代理节点服务订阅',
    CPU: '/4CPU内核',
    payment: '管理账户',
    manageTip: '确定打开订阅管理吗？',
    subscribeService: '订阅TVU Media Hub服务',
    save: '保存为',
    perMonth: '每月',
    eachGroup: '每个组有',
    bitrateTip: '对于一个低视频比特率输出',
    confirm: '确认'
  }
}
